<template>
	<div>
		<visualization-data-cart
			v-show="!isPreparingRequesting"
			:choosenDataIdx.sync="choosenDataIdx"
			:isFinishProcessChoosenData="isFinishProcessChoosenData"
			:selectedDataList="selectedDataList"
		/>

		<visualization-table-chart-menu
			v-show="choosenDataIdx != null"
			:isFinishProcessChoosenData="isFinishProcessChoosenData"
			:isTable="isTable"
			:isChart="isChart"
			:isMap="isMap"
			:updateIsTable="updateIsTable"
			:updateIsChart="updateIsChart"
			:updateIsMap="updateIsMap"
		/>

		<visualization-table-container
			v-show="choosenDataIdx != null && isTable && !isChart"
			:choosenDataIdx="choosenDataIdx"
			:choosenData="choosenData"
			:choosenRowFields="choosenRowFields"
			:choosenColumnFields="choosenColumnFields"
			:choosenDimensions="choosenDimensions"
			:isFinishProcessChoosenData="isFinishProcessChoosenData"
			:selectedDataList="selectedDataList"
			:tabelDinamisSelectedDataListAlreadyCollapsed="
				tabelDinamisSelectedDataListAlreadyCollapsed
			"
			:updateIsFinishProcessChoosenData="updateIsFinishProcessChoosenData"
			:isProcessingNow="isProcessingNow"
		/>

		<visualization-chart-container
			v-show="choosenDataIdx != null && !isTable && isChart"
			:choosenData="choosenData"
			:choosenDimensions="choosenDimensions"
			:selectedDataList="selectedDataList"
			:choosenDataIdx="choosenDataIdx"
			:isProcessingNow="isProcessingNow"
		/>
	</div>
</template>

<!-- javascript section-->
<script type="module">
//import js modules section
import VisualizationDataCart from "./VisualizationMainContainer/VisualizationDataCart.vue";
import VisualizationTableContainer from "./VisualizationMainContainer/VisualizationTableContainer.vue";
import VisualizationTableChartMenu from "./VisualizationMainContainer/VisualizationTableChartMenu.vue";
import VisualizationChartContainer from "./VisualizationMainContainer/VisualizationChartContainer.vue";

//local registration for output component
export default {
	name: "VisualizationMainContainer",
	data() {
		return {
			choosenDataIdx: null,
			isFinishProcessChoosenData: null,
			tabelDinamisSelectedDataListAlreadyCollapsed: false,
			isTable: true,
			isChart: false,
			isMap: false,
		};
	},
	props: [
		"isPreparingRequesting",
		"dataOutput",
		"dimensions",
		"rowFields",
		"columnFields",
		"selectedDataList",
		"isProcessingNow",
		// "updateColumnFields",
		// "updateRowFields",
	],
	created() {},
	destroyed() {},
	mounted: function () {
		this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
			if (
				collapseId === "tabel-dinamis-selected-data-list-collapse" &&
				isJustShown === false
			) {
				this.tabelDinamisSelectedDataListAlreadyCollapsed = true;
			} else if (
				collapseId === "tabel-dinamis-selected-data-list-collapse" &&
				isJustShown === true
			) {
				this.tabelDinamisSelectedDataListAlreadyCollapsed = false;
			}
		});
	},
	computed: {
		choosenData() {
			return this.choosenDataIdx == null
				? []
				: this.dataOutput[this.choosenDataIdx];
		},
		choosenRowFields() {
			return this.choosenDataIdx == null
				? []
				: this.rowFields[this.choosenDataIdx];
		},
		choosenColumnFields() {
			return this.choosenDataIdx == null
				? []
				: this.columnFields[this.choosenDataIdx];
		},
		choosenDimensions() {
			return this.choosenDataIdx == null
				? {}
				: this.dimensions[this.choosenDataIdx];
		},
	},
	watch: {
		choosenDataIdx(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.isTable = true;
				this.isChart = false;
				this.isMap = false;
			}
		},
	},
	methods: {
		updateIsFinishProcessChoosenData(val) {
			this.isFinishProcessChoosenData = val;
		},
		updateIsTable(val) {
			this.isTable = val;
		},
		updateIsChart(val) {
			this.isChart = val;
		}, 
		updateIsMap(val) {
			this.isMap = val;
		},
		/* updateChoosenRowFields(val) {
			let rowFields = this.rowFields;
			rowFields[this.choosenDataIdx] = val;
			this.updateRowFields(rowFields);
		}, */
		/* updateChoosenColumnFields(val) {
			let columnFields = this.columnFields;
			columnFields[this.choosenDataIdx] = val;
			this.updateColumnFields(columnFields);
		}, */
	},
	components: {
		"visualization-data-cart": VisualizationDataCart,
		"visualization-table-container": VisualizationTableContainer,
		"visualization-table-chart-menu": VisualizationTableChartMenu,
		"visualization-chart-container": VisualizationChartContainer,
	},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

.tabel-dinamis-rotate-half {
	transform: rotate(180deg) !important;
}

#tabel-dinamis-selected-data-list-collapse-icon {
	transition: 0.5s;
	border: 1px solid transparent !important;
}

.popover-overflow-y {
	max-width: 50% !important;
	// max-height: 250px !important;
	overflow: auto !important;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 15-09-2022 -->